import { Controller, useFormContext } from 'react-hook-form';
import { FormInputText } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

import type { RiderFormValues } from '../../../types';

const mqDesktop = `@media (max-width: ${variables.breakpoints.desktop - 1}px)`;

export const CodeWordSubsection = () => {
  const { control } = useFormContext<RiderFormValues>();

  return (
    <Row data-testid="code-word-subsection">
      <LeftColumn>
        <LabelRow>
          <Label htmlFor="codeWord">Code word</Label>
          <RequiredIndicator aria-hidden="true">*</RequiredIndicator>
        </LabelRow>
        <Controller
          control={control}
          name="codeWord"
          render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
            <FormInputText
              id="codeWord"
              name="codeWord"
              data-testid="code-word"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              placeholder="Enter code word"
              variant="outlined"
              inputProps={{ 'aria-required': true }}
              error={!!error}
              helperText={error ? error.message : ''}
              sx={{ width: '323px', [`@media (max-width: ${variables.breakpoints.desktop - 1}px)`]: { width: '100%' } }}
            />
          )}
        />
      </LeftColumn>
      <Alert role="note">
        Set a code word the rider can remember. The CareDriver will say this at pickup so the rider knows they are with
        the right person.
      </Alert>
    </Row>
  );
};

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  ${mqDesktop} {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  width: 328px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${mqDesktop} {
    width: 100%;
  }
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 700;
  color: ${colorTokens.text.medium};
`;

const RequiredIndicator = styled.span`
  color: ${colorTokens.error.main};
  font-size: 13px;
`;

const Alert = styled.div`
  flex: 1;
  background: ${colorTokens.surface.neutral};
  padding: 14px 16px;
  border-radius: 4px;
  font-size: 13px;
  color: ${colorTokens.text.medium};
`;
